const staffRoles = ['admin_referensiel', 'coach']

const userHasStaffRole = (userRoles) => {
  return userRoles.some((r) => staffRoles.includes(r))
}

export default userHasStaffRole
